// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-container {\n  margin: 20px;\n}\n\n.header-container img {\n  height: 30px;\n}\n\n@media screen and (min-width: 980px) {\n  .header-container img {\n    height: 40px;\n  }\n}\n", ""]);
// Exports
module.exports = exports;
